import emptySplitApi from "../utils/rtk";
import { CommonBody, RoleTypes, SubadminTypes } from "../types/General";
import { END_POINTS } from "../constants/urls";

type CommonResponseType = {
  status: number;
  message: string;
};
type GetSubadminsResponse = {
  length: number;
  start: number;
  response_object: SubadminTypes[];
  total_records: number;
  from_date?: string;
  to_date?: string;
};

export const subadminApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    // roles

    getAllRoles: builder.query<CommonResponseType & { data: RoleTypes[] }, void>({
      query: () => ({
        url: END_POINTS.getAllRoles,
        method: "GET",
      }),
    }),

    deleteRole: builder.query<
      CommonResponseType & { data: RoleTypes },
      { id: number | null }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteRole}${id}/`,
        method: "DELETE",
      }),
    }),

    roleDetail: builder.query<
      CommonResponseType & { data: RoleTypes | null },
      { id: number | null }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.roleDetail}${id}/`,
        method: "GET",
      }),
    }),
    updateRole: builder.mutation<
      CommonResponseType & { data: RoleTypes },
      { body: CommonBody; id: number }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateRole}${id}/`,
        method: "PUT",
        body,
      }),
    }),
    addRole: builder.mutation<
      CommonResponseType & { data: RoleTypes },
      CommonBody
    >({
      query: (body) => ({
        url: END_POINTS.addRole,
        method: "POST",
        body,
      }),
    }),

    // suadmin
    getAllSubadmins: builder.mutation<
      CommonResponseType & { data: GetSubadminsResponse },
      CommonBody
    >({
      query: (body) => ({
        url: END_POINTS.getSubadmins,
        method: "POST",
        body,
      }),
    }),

    deleteSubadmin: builder.query<
      CommonResponseType & { data: SubadminTypes },
      { id: number | null }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteSubadmin}${id}/`,
        method: "DELETE",
      }),
    }),

    subadminDetail: builder.query<
      CommonResponseType & { data: SubadminTypes | null },
      { id: number | null }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.getSubadminById}${id}/`,
        method: "GET",
      }),
    }),
    updateSubadmin: builder.mutation<
      CommonResponseType & { data: SubadminTypes },
      { body: CommonBody; id: number }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateSubadmin}${id}/`,
        method: "PUT",
        body,
      }),
    }),
    addSubadmin: builder.mutation<
      CommonResponseType & { data: SubadminTypes },
      CommonBody
    >({
      query: (body) => ({
        url: END_POINTS.addSubadmin,
        method: "POST",
        body,
      }),
    }),
    changeSubadminStatus: builder.mutation<
      CommonResponseType & { data: SubadminTypes },
      { body: CommonBody; id: number }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.subadminStatusChange}${id}/`,
        method: "PUT",
        body,
      }),
    }),
  }),
});

export const {
  useLazyGetAllRolesQuery,
  useLazyDeleteRoleQuery,
  useLazyRoleDetailQuery,
  useAddRoleMutation,
  useUpdateRoleMutation,

  useAddSubadminMutation,
  useUpdateSubadminMutation,
  useLazyDeleteSubadminQuery,
  useLazySubadminDetailQuery,
  useGetAllSubadminsMutation,
  useChangeSubadminStatusMutation,
} = subadminApi;
